export function createTheme(config) {
    return config;
}
export const bacchusTheme = createTheme({
    primary: { from: '#f97316', to: '#f59e0b' },
    brandName: 'FIREBREAK',
    brandSubtext: 'BACCHUS',
});
export const vestaTheme = createTheme({
    primary: { from: '#3b82f6', to: '#60a5fa' },
    brandName: 'FIREBREAK',
    brandSubtext: 'VESTA',
});
export const startTheme = createTheme({
    primary: { from: '#d4a574', to: '#e0b88a' },
    brandName: '00 START',
});
//# sourceMappingURL=theme.js.map